import { Controller } from "@hotwired/stimulus"
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

export default class extends Controller {

  static values = { businessHours: Array,
                    events: Array }

  connect() {
    this.calendar = new Calendar(this.element, {
      plugins: [ dayGridPlugin, timeGridPlugin, listPlugin ],
      initialView: 'timeGridWeek',
      headerToolbar: {
        left: 'prev',
        center: 'title',
        right: 'next'
      },
      height: 'auto',
      allDaySlot: this.eventsValue.some(event => event.allDay),
      eventClick: function(info) {
        if (info.event.url) {
          window.open(info.event.url);
          return false;
        }
      },
      datesSet: (info) => this.fitHours(info.start, info.end),
      events: this.eventsValue,
      businessHours: this.businessHoursValue,
    });
    this.calendar.render();
  }

  disconnect() {
    this.calendar?.destroy();
  }

  fitHours(rangeStart, rangeEnd) {
    const minutes = this.businessHoursValue.flatMap(hours => [ this.toMinutes(hours.startTime), this.toMinutes(hours.endTime) ]);

    this.eventsValue.forEach(event => {
      const start = new Date(event.start);
      const end = new Date(event.end || event.start);
      if (end <= rangeStart || start >= rangeEnd) return;

      minutes.push(start.getHours() * 60 + start.getMinutes());
      minutes.push(start.toDateString() === end.toDateString() ? end.getHours() * 60 + end.getMinutes() : 24 * 60);
    });

    if (minutes.length === 0) return;

    const first = Math.floor(Math.min(...minutes) / 60) * 60;
    const last = Math.max(Math.ceil(Math.max(...minutes) / 60) * 60, first + 60);
    const slotMinTime = this.toTime(first);
    const slotMaxTime = this.toTime(last);

    if (this.calendar.getOption('slotMinTime') !== slotMinTime) this.calendar.setOption('slotMinTime', slotMinTime);
    if (this.calendar.getOption('slotMaxTime') !== slotMaxTime) this.calendar.setOption('slotMaxTime', slotMaxTime);
  }

  toMinutes(time) {
    const [ hours, minutes ] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  toTime(totalMinutes) {
    const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
    const minutes = String(totalMinutes % 60).padStart(2, '0');
    return `${hours}:${minutes}:00`;
  }
}
